import { useLocation } from "react-router-dom";
// import { AudioLlamada } from "./features/AudioLlamada/AudioLlamada";
import { FormularioEvaluacion } from "./features/FormularioEvaluacion/FormularioEvaluacion";
import { useNuevaEvaluacion } from "./hooks/useNuevaEvaluacion";
import { EvaluacionesLayout } from "./shared/EvaluacionesLayout";

function NuevaEvaluacion() {
  const modelo = useNuevaEvaluacion();

  return (
    <EvaluacionesLayout
      titulo="Nueva evaluación"
      subtitulo={modelo.formularioListo ? modelo.plantilla.nombre : undefined}
      volver={modelo.volver}
      // accion={<AudioLlamada key={modelo.evaluacionOrigen?.id} duracion={modelo.evaluacionOrigen?.duracion} />}
    >
      <FormularioEvaluacion modelo={modelo} />
    </EvaluacionesLayout>
  );
}

export function NuevaEvaluacionPage() {
  const location = useLocation();
  return <NuevaEvaluacion key={location.search} />;
}
